import Axios from "axios";

export default {
  install(Vue) {
    (Vue.prototype.formatDate = (date, fmt) => {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
          );
        }
      }
      return fmt;
    }),
      //时间戳转日期
      (Vue.prototype.timestampToTime = timestamp => {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          date.getDate() < 10
            ? "0" + date.getDate() + " "
            : date.getDate() + " ";
        var h =
          date.getHours() < 10
            ? "0" + date.getHours() + ":"
            : date.getHours() + ":";
        var m =
          date.getMinutes() < 10
            ? "0" + date.getMinutes() + ":"
            : date.getMinutes() + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      }),
      //时间判断
      (Vue.prototype.isTime = (time1, time2) => {
        if (time1 && time2 && time2 - time1 < 0) {
          return false;
        } else {
          return true;
        }
      }),
      //判断是否是数字
      (Vue.prototype.isNumber = date => {
        var ret = new RegExp("^[1-9]d*|0$");
        return ret.test(date);
      }),
      //校验密码为6-16位的数字和字母组合
      (Vue.prototype.checkPwd = (pwd, reg) => {
        //var reg =/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
        //var reg =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>|\[\]\\\/?])[\S\s]{8,16}$/
        var re = new RegExp(reg)
        if (re.test(pwd)) {
          return true;
        }else{
          return false;
        }
      }),
      //去除字符串中的img标签
      (Vue.prototype.filterImg = value => {
          var str = value.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,'').replace(/&nbsp;/ig,'');
          return str;
      }),
      //判断是汉字
      (Vue.prototype.isName = date => {
        var reg = /^[\u4E00-\u9FA5]{0,5}$/;
        return reg.test(date);
      }),
      //移除HTML标签代码
      (Vue.prototype.removeHTMLTag = date => {
        var str = date.replace(/<[^>]+>/g, "");
        return str;
      }),
      //判断是学号
      (Vue.prototype.isStudentNum = date => {
        var reg = /^[A-Za-z0-9]{0,20}$/;
        return reg.test(date);
      }),
      (Vue.prototype.getWeek = date => {
        var day = new Date(date);
        var today = new Array(
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        );
        var week = today[day.getDay()];
        return week;
      }),
      (Vue.prototype.styleSet = function() {
        $("html").css({ "overflow-x": "hidden", "overflow-y": "auto" });
        $("#body").addClass("body");
      }),
      //安卓ios发起支付页面
      (Vue.prototype.weiXinPayInfo = params => {
        //判断是安卓还是ios
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var paramsJson = JSON.stringify(params);
        if (bIsIphoneOs) {
          //ios
          window.webkit.messageHandlers.wxPayInfo.postMessage(paramsJson);
        }
        if (bIsAndroid) {
          //安卓
          window.jsObj.wxPayInfo(paramsJson);
        }
      }),
      (Vue.prototype.getChangeDay = function(now, day) {
        var nowDate = new Date(now).getTime();
        nowDate += 24 * 60 * 60 * 1000 * day;
        return this.formatDate(new Date(nowDate), "yyyy-MM-dd");
      }),
      (Vue.prototype.exportExcel= function(url, fileName, options) {
        const loading = this.$loading({
          lock: true,
          text: '正在下载，请稍后......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        return new Promise((resolve, reject) => {
          console.log(`${url} 请求数据，参数=>`, JSON.stringify(options))
          Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
          Axios({
            method: 'post',
            url: url, // 请求地址
            data: options, // 参数
            responseType: 'blob' // 表明返回服务器返回的数据类型
          }).then(
              response => {
                loading.close();
                resolve(response.data)
                let blob = new Blob([response.data], {
                  type: 'application/vnd.ms-excel'
                })
                console.log(blob)
                if (window.navigator.msSaveOrOpenBlob) {
                  // console.log(2)
                  navigator.msSaveBlob(blob, fileName)
                } else {
                  // console.log(3)
                  var link = document.createElement('a')
                  link.href = window.URL.createObjectURL(blob)
                  link.download = fileName
                  link.click()
                  //释放内存
                  window.URL.revokeObjectURL(link.href)
                }
              },
              err => {
                loading.close();
                reject(err)
              }
          )
        })
      }),
      //判断输入内容是否包含表情
      (Vue.prototype.isEmojiCharacter = function(substring) {
        for (var i = 0; i < substring.length; i++) {
          var hs = substring.charCodeAt(i);
          if (0xd800 <= hs && hs <= 0xdbff) {
            if (substring.length > 1) {
              var ls = substring.charCodeAt(i + 1);
              var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
              if (0x1d000 <= uc && uc <= 0x1f77f) {
                return true;
              }
            }
          } else if (substring.length > 1) {
            var ls = substring.charCodeAt(i + 1);
            if (ls == 0x20e3) {
              return true;
            }
          } else {
            if (0x2100 <= hs && hs <= 0x27ff) {
              return true;
            } else if (0x2b05 <= hs && hs <= 0x2b07) {
              return true;
            } else if (0x2934 <= hs && hs <= 0x2935) {
              return true;
            } else if (0x3297 <= hs && hs <= 0x3299) {
              return true;
            } else if (
              hs == 0xa9 ||
              hs == 0xae ||
              hs == 0x303d ||
              hs == 0x3030 ||
              hs == 0x2b55 ||
              hs == 0x2b1c ||
              hs == 0x2b1b ||
              hs == 0x2b50
            ) {
              return true;
            }
          }
        }
      });
    (Vue.prototype.numberInputHandler  = (value, field, context) => {
      // 允许数字和小数点，过滤其他字符
      let filtered = value.replace(/[^\d.]/g, '')
      // 处理多个小数点的情况
      filtered = filtered.replace(/\.{2,}/g, '.')
      // 拆分整数和小数部分
      const parts = filtered.split('.')

      // 处理以小数点开头的情况（如".01" -> "0.01"）
      if (filtered.startsWith('.')) {
        parts[0] = '0'
        parts[1] = parts[1] || ''
      }

      // 处理整数部分（允许0开头的情况）
      if (parts[0]) {
        // 仅当整数部分有多个前导0且没有小数点时替换（保留单个0）
        if (!filtered.includes('.') && parts[0].length > 1) {
          parts[0] = parts[0].replace(/^0+/, '') || '0'
        }
      }

      // 处理小数部分（最多两位）
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2)
        filtered = `${parts[0]}.${parts[1]}`
      } else if (filtered !== '') {
        filtered = parts[0]
      }

      // 更新上下文中的字段值
      context[field] = filtered === '' ? 0 : filtered
    });
  }
};
